export default {"src":"/_next/static/media/section3-img.dbf4ea8c.svg","height":401,"width":450,"blurWidth":0,"blurHeight":0};